export const phoneRegexp: RegExp = /^((\+?)(?<prefix>(48)))?(?<number>\d{9})$/i;
